export const translations = {
  am: {
    // Navigation
    nav: {
      tariffs: "Սակագներ",
      speedtest: "Արագության Ստուգում",
      coverage: "Հասանելիություն",
      about: "Մեր Մասին",
      contacts: "Կապ",
      callUs: "Զանգահարել՝ 060 666 999",
    },

    // Hero Banner
    hero: {
      badge: "Հուսալի Կապ Հայաստանում 2001-ից",
      titlePart1: "ԳԵՐԱՐԱԳ",
      titlePart2: "ԻՆՏԵՐՆԵՏ",
      titlePart3: "& ԹՎԱՅԻՆ",
      titlePart4: "CATV",
      subtitle: "Օպտիկամանրաթելային գերկայուն կապ մինչև 200 Մբիթ/վրկ արագությամբ և 100+ բարձրակարգ թվային հեռուստաալիքներ Ձեր տան և բիզնեսի համար:",
      viewTariffs: "Դիտել Սակագները",
      callDirect: "Զանգահարել՝ 060 666 999",
    },

    // Tariffs Section
    tariffs: {
      badge: "Թարմացված Սակագներ",
      title: "Ընտրեք Ձեր Փաթեթը",
      subtitle: "Գերարագ օպտիկամանրաթելային ինտերնետ և թվային հեռուստաալիքներ առանց խափանումների: Ընտրեք տան կամ բիզնեսի համար:",
      tabBundle: "CATV + Ինտերնետ",
      tabFiber: "Օպտիկական Ինտերնետ",
      tabCorporate: "Կորպորատիվ",
      popularBadge: "Ամենապահանջված",
      currency: "֏ / ամիս",
      noHiddenFees: "Առանց թաքնված վճարների",
      speedLabel: "Ինտերնետ արագություն",
      speedUpTo: "Մինչև",
      speedUnit: "Մբ/վ",
      channelsLabel: "Թվային CATV",
      channelsSub: "Հեռուստաալիքներ",
      channelsUnit: "Ալիք",
      freeWifi: "Անվճար Wi-Fi ակտիվացում",
      techMonitoring: "24/7 Տեխնիկական մոնիթորինգ",
      unlimitedTraffic: "Անսահմանափակ տրաֆիկ",
      transparencyTitle: "Թափանցիկության ցուցանիշ",
      normallyAvailable: "Սովորաբար հասանելի՝",
      minimumSpeed: "Նվազագույն երաշխավորված՝",
      callButton: "Զանգահարել՝ 060 666 999",
      helpTitle: "Դժվարանո՞ւմ եք ընտրել համապատասխան փաթեթը",
      helpSubtitle: "Մեր մասնագետները կօգնեն գտնել Ձեր տարածքի և կարիքների համար լավագույն լուծումը:",
      helpButton: "Ստանալ Խորհրդատվություն",
    },

    // Speed Test & Calculator
    speedtest: {
      badge: "Արագություն և Ճշգրտություն",
      title: "Արագության Ստուգում & Հաշվիչ",
      subtitle: "Ստուգեք Ձեր ներկայիս կապի իրական արագությունը կամ հաշվարկեք Ձեր տան համար անհրաժեշտ թողունակությունը:",
      serverTestBadge: "Ուղիղ Սերվերային Թեստ",
      serverTestTitle: "Ինտերնետ կապի արագության ստուգում",
      serverTestDesc: "Ներբեռնեք 10 ԳԲ ծավալով փորձնական ֆայլը անմիջապես «Ռեալ Թայմ»-ի կենտրոնական սերվերից՝ Ձեր կապի իրական առավելագույն թողունակությունն ու կայունությունը չափելու համար:",
      noProxy: "Առանց արտաքին միջնորդների և VPN խոչընդոտի",
      realMeasure: "Իրական պրովայդերային հոսքի չափում",
      downloadButton: "Ներբեռնել Speed Test ֆայլը (10 GB)",
      calcBadge: "Ինտերակտիվ Գործիք",
      calcTitle: "Ինտերնետի Կարիքների Հաշվիչ",
      questionPeople: "Քանի՞ մարդ է միաժամանակ օգտվում համացանցից:",
      peopleSmall: "1 - 2 Անձ",
      peopleMedium: "3 - 4 Անձ",
      peopleLarge: "5+ Անձ",
      questionNeeds: "Ի՞նչ նպատակներով եք հիմնականում օգտագործում:",
      needStreaming: "4K Ֆիլմեր",
      needGaming: "Օնլայն Խաղեր",
      needWork: "Հեռավար Աշխատանք",
      needSmartHome: "Smart Home",
      recBadge: "Խորհուրդ տրվող փաթեթը",
      callOperator: "Զանգահարել օպերատորին՝ 060 666 999",
    },

    // Coverage Section
    coverage: {
      badge: "Ցանցի Ծածկույթ",
      title: "Հասանելիության Քարտեզ",
      subtitle: "«Ռեալ Թայմ»-ի օպտիկամանրաթելային ցանցն ընդգրկում է տասնյակ բնակավայրեր: Ստուգեք Ձեր հասցեն ստորև:",
      mapTitle: "Ինտերակտիվ Քարտեզ",
      settlementsCount: "Բնակավայր",
      markerFiber: "Օպտիկամանրաթելային ծածկույթի կետեր",
      markerActive: "Ակտիվ հասանելիություն",
      searchPlaceholder: "Փնտրել բնակավայր (օր. Օշական, Ալաշկերտ...)",
      allRegions: "Բոլորը",
      noResults: "Բնակավայր չի գտնվել այս անվանումով",
      fiberAvailable: "Օպտիկա",
      fiberNone: "Օպտիկա չկա",
      cantFind: "Չգտա՞ք Ձեր բնակավայրը",
      checkByCall: "Ճշտել Զանգով՝ 060 666 999",
    },

    // About Section
    about: {
      badge: "Մեր Պատմությունը և Առաքելությունը",
      title: "Հուսալի Կապ Հայաստանի Բնակավայրերում",
      storyP1: "«Ռեալ Թայմ» ՍՊ ընկերությունը հիմնադրվել է 2001 թվականին: 2007 թվականից ընկերությունը սկսել է համացանցի հասանելիության ծառայության մատուցումը Երևանի տարածքում, իսկ հետագայում ընդլայնել իր ծածկույթը ՀՀ մարզային տասնյակ բնակավայրերում:",
      storyP2: "Կազմակերպության գլխավոր առաքելությունն է ինտերնետը հասանելի և բարձրորակ դարձնել նաև գյուղական համայնքներում: Կիրառելով ժամանակակից սարքավորումներ և սպասարկման նորագույն տեխնոլոգիաներ՝ մենք շարունակաբար ընդլայնում ենք օպտիկական ցանցը՝ ապահովելով գերարագ կապ յուրաքանչյուր ընտանիքի համար:",
      feat1Title: "Գերարագ Օպտիկա (FTTH)",
      feat1Desc: "Ժամանակակից օպտիկամանրաթելային մալուխ անմիջապես Ձեր բնակարան կամ գրասենյակ:",
      feat2Title: "100+ Թվային CATV Ալիքներ",
      feat2Desc: "Բյուրեղյա մաքուր HD պատկեր և հարուստ ժամանցային, լրատվական ու մանկական ալիքներ:",
      feat3Title: "99.9% Կայուն Կապ",
      feat3Desc: "Անխափան սերվերային հանգույցներ և ռեզերվային մայրուղիներ եղանակային ցանկացած պայմաններում:",
      feat4Title: "Ամենօրյա Աջակցություն",
      feat4Desc: "Մեր տեխնիկական թիմը հասանելի է 09:00-ից մինչև 24:00՝ արագ արձագանքման երաշխիքով:",
    },

    // Contacts Section
    contacts: {
      badge: "Հետադարձ Կապ",
      title: "Կապ Մեզ Հետ",
      subtitle: "Միացման, սակագների կամ տեխնիկական սպասարկման համար զանգահարեք մեր շուրջօրյա աջակցության կենտրոն:",
      supportBannerBadge: "Շուրջօրյա Սպասարկում",
      supportBannerTitle: "Զանգերի Սպասարկման Կենտրոն",
      supportBannerHours: "Աշխատանքային ժամեր՝ 09:00 - 24:00 (Ամեն օր)",
      mobilePhonesTitle: "Բջջային Հեռախոսահամարներ",
      emailTitle: "Էլեկտրոնային Փոստ",
      emailHrTitle: "Կադրերի Բաժին / Կարիերա",
      emailGeneralTitle: "Ընդհանուր Հարցեր & Առաջարկներ",
      quickReply: "Արագ Պատասխան",
      quickReplyDesc: "Էլեկտրոնային նամակներին պատասխանում ենք աշխատանքային օրերին 24 ժամվա ընթացքում:",
      officeTitle: "Իրավաբանական & Գլխավոր Գրասենյակ",
      addressLabel: "Հասցե",
      addressValue: "ՀՀ ք. Վաղարշապատ (Էջմիածին), Շահումյան փողոց 39",
      coverageZoneLabel: "Սպասարկման Գոտի",
      coverageZoneValue: "Երևան, Արմավիրի մարզ, Արագածոտնի մարզ և հարակից գյուղական համայնքներ:",
      officeHoursLabel: "Գրասենյակի Աշխատաժամանակ",
      officeHoursValue: "Երկուշաբթի - Շաբաթ՝ 09:00 - 18:00",
      callAction: "Զանգահարել",
      copyAction: "Պատճենել",
      copied: "Պատճենված է",
      operatorsOnline: "Օպերատորներն առցանց են",
      viewCoverageMap: "Դիտել Ծածկույթի Քարտեզում",
      openInMaps: "Բացել Քարտեզում",
      mainHotlineBadge: "Հիմնական Թեժ Գիծ",
      callCenterDuty: "Տեխնիկական հերթապահություն 24/7",
    },

    // Footer
    footer: {
      desc: "«Ռեալ Թայմ» ՍՊԸ՝ գերարագ օպտիկամանրաթելային ինտերնետի և թվային CATV հեռուստատեսության հուսալի պրովայդեր Հայաստանում 2001 թվականից:",
      quickLinks: "Արագ Անցումներ",
      reports: "Հաշվետվություններ",
      terms: "Պայմաններ և Դրույթներ",
      contactInfo: "Կոնտակտային Տվյալներ",
      address: "ՀՀ ք. Վաղարշապատ, Շահումյան 39",
      allRights: "Բոլոր իրավունքները պաշտպանված են:",
      backToTop: "Վերև",
    },

    // Documents Modal
    docsModal: {
      badge: "Պաշտոնական Փաստաթղթեր",
      title: "Թափանցիկություն և Կանոնակարգեր",
      desc: "«Ռեալ Թայմ» ՍՊԸ հրապարակային հաշվետվություններն ու բաժանորդագրության պաշտոնական պայմանները:",
      tabReports: "Հաշվետվություններ",
      tabTerms: "Պայմաններ և Դրույթներ",
      downloadPdf: "PDF",
      notFound: "Փաստաթղթեր չեն գտնվել",
    },
  },

  ru: {
    // Navigation
    nav: {
      tariffs: "Тарифы",
      speedtest: "Проверка Скорости",
      coverage: "Зона Покрытия",
      about: "О Нас",
      contacts: "Контакты",
      callUs: "Позвонить: 060 666 999",
    },

    // Hero Banner
    hero: {
      badge: "Надежный Провайдер в Армении с 2001 года",
      titlePart1: "СВЕРХСКОРОСТНОЙ",
      titlePart2: "ИНТЕРНЕТ",
      titlePart3: "И ЦИФРОВОЕ",
      titlePart4: "ТЕЛЕВИДЕНИЕ CATV",
      subtitle: "Сверхстабильное оптоволоконное соединение со скоростью до 200 Мбит/с и 100+ премиальных цифровых телеканалов для вашего дома и бизнеса.",
      viewTariffs: "Смотреть Тарифы",
      callDirect: "Позвонить: 060 666 999",
    },

    // Tariffs Section
    tariffs: {
      badge: "Актуальные Тарифы",
      title: "Выберите Свой Пакет",
      subtitle: "Высокоскоростной оптоволоконный интернет и цифровое телевидение без перебоев. Для дома и бизнеса.",
      tabBundle: "CATV + Интернет",
      tabFiber: "Оптоволоконный Интернет",
      tabCorporate: "Корпоративный",
      popularBadge: "Популярный",
      currency: "֏ / месяц",
      noHiddenFees: "Без скрытых платежей",
      speedLabel: "Скорость интернета",
      speedUpTo: "До",
      speedUnit: "Мбит/с",
      channelsLabel: "Цифровое CATV",
      channelsSub: "Телеканалы",
      channelsUnit: "Каналов",
      freeWifi: "Бесплатная активация Wi-Fi",
      techMonitoring: "24/7 Технический мониторинг",
      unlimitedTraffic: "Безлимитный трафик",
      transparencyTitle: "Показатели прозрачности",
      normallyAvailable: "Обычно доступно:",
      minimumSpeed: "Минимально гарантировано:",
      callButton: "Позвонить: 060 666 999",
      helpTitle: "Затрудняетесь с выбором тарифа?",
      helpSubtitle: "Наши специалисты помогут подобрать оптимальное решение для вашего региона и потребностей.",
      helpButton: "Получить Консультацию",
    },

    // Speed Test & Calculator
    speedtest: {
      badge: "Скорость и Точность",
      title: "Проверка Скорости & Калькулятор",
      subtitle: "Проверьте реальную скорость вашего соединения или рассчитайте необходимую пропускную способность для вашего дома.",
      serverTestBadge: "Прямой Серверный Тест",
      serverTestTitle: "Проверка реальной скорости интернета",
      serverTestDesc: "Скачайте тестовый файл объемом 10 ГБ напрямую с центрального сервера «Real Time» для точного измерения максимальной скорости и стабильности.",
      noProxy: "Без внешних прокси и ограничений VPN",
      realMeasure: "Точное измерение потока провайдера",
      downloadButton: "Скачать файл Speed Test (10 GB)",
      calcBadge: "Интерактивный Инструмент",
      calcTitle: "Калькулятор Потребностей Интернета",
      questionPeople: "Сколько человек одновременно пользуются интернетом?",
      peopleSmall: "1 - 2 Чел.",
      peopleMedium: "3 - 4 Чел.",
      peopleLarge: "5+ Чел.",
      questionNeeds: "Для каких целей чаще всего используется интернет?",
      needStreaming: "4K Фильмы",
      needGaming: "Онлайн Игры",
      needWork: "Удаленная Работа",
      needSmartHome: "Умный Дом",
      recBadge: "Рекомендуемый пакет",
      callOperator: "Позвонить оператору: 060 666 999",
    },

    // Coverage Section
    coverage: {
      badge: "Зона Покрытия",
      title: "Карта Доступности",
      subtitle: "Оптоволоконная сеть «Real Time» охватывает десятки населенных пунктов. Проверьте ваш адрес ниже:",
      mapTitle: "Интерактивная Карта",
      settlementsCount: "Населенных пунктов",
      markerFiber: "Точки оптоволоконного покрытия",
      markerActive: "Активное подключение",
      searchPlaceholder: "Поиск населенного пункта (напр. Ошакан, Алашкерт...)",
      allRegions: "Все",
      noResults: "Населенный пункт не найден",
      fiberAvailable: "Оптика",
      fiberNone: "Нет оптики",
      cantFind: "Не нашли свой населенный пункт?",
      checkByCall: "Уточнить по звонку: 060 666 999",
    },

    // About Section
    about: {
      badge: "Наша История и Миссия",
      title: "Надежная Связь в Регионах Армении",
      storyP1: "Компания ООО «Реал Тайм» была основана в 2001 году. С 2007 года компания начала предоставлять услуги доступа в интернет в Ереване, а затем расширила покрытие на десятки населенных пунктов в областях Армении.",
      storyP2: "Главная миссия организации — сделать качественный и скоростной интернет доступным для сельских общин. Используя передовое оборудование и современные технологии обслуживания, мы непрерывно расширяем оптоволоконную сеть, обеспечивая сверхбыструю связь для каждой семьи.",
      feat1Title: "Сверхскоростная Оптика (FTTH)",
      feat1Desc: "Современный оптоволоконный кабель прямо в вашу квартиру или офис.",
      feat2Title: "100+ Цифровых Каналов CATV",
      feat2Desc: "Кристально чистое HD-качество, познавательные, новостные и детские каналы.",
      feat3Title: "99.9% Стабильность Сети",
      feat3Desc: "Бесперебойные серверные узлы и резервные магистрали при любых погодных условиях.",
      feat4Title: "Ежедневная Поддержка",
      feat4Desc: "Наша служба технической поддержки доступна с 09:00 до 24:00 с быстрым реагированием.",
    },

    // Contacts Section
    contacts: {
      badge: "Обратная Связь",
      title: "Свяжитесь с Нами",
      subtitle: "По вопросам подключения, тарифов или технической поддержки звоните в наш круглосуточный центр обслуживания:",
      supportBannerBadge: "Круглосуточная Поддержка",
      supportBannerTitle: "Центр Обслуживания Вызовов",
      supportBannerHours: "Часы работы: 09:00 - 24:00 (Ежедневно)",
      mobilePhonesTitle: "Номера Мобильных Операторов",
      emailTitle: "Электронная Почта",
      emailHrTitle: "Отдел Кадров / Карьера",
      emailGeneralTitle: "Общие Вопросы & Предложения",
      quickReply: "Быстрый Ответ",
      quickReplyDesc: "Отвечаем на электронные письма в рабочие дни в течение 24 часов.",
      officeTitle: "Юридический & Главный Офис",
      addressLabel: "Адрес",
      addressValue: "РА г. Вагаршапат (Эчмиадзин), улица Шаумяна 39",
      coverageZoneLabel: "Зона Обслуживания",
      coverageZoneValue: "Ереван, Армавирская область, Арагацотнская область и прилегающие общины.",
      officeHoursLabel: "Часы Работы Офиса",
      officeHoursValue: "Понедельник - Суббота: 09:00 - 18:00",
      callAction: "Позвонить",
      copyAction: "Скопировать",
      copied: "Скопировано",
      operatorsOnline: "Операторы онлайн",
      viewCoverageMap: "Посмотреть на Карте Покрытия",
      openInMaps: "Открыть на Карте",
      mainHotlineBadge: "Основная Линия",
      callCenterDuty: "Техническое дежурство 24/7",
    },

    // Footer
    footer: {
      desc: "ООО «Реал Тайм» — надежный провайдер высокоскоростного оптоволоконного интернета и цифрового телевидения в Армении с 2001 года.",
      quickLinks: "Быстрые Ссылки",
      reports: "Отчеты",
      terms: "Условия и Положения",
      contactInfo: "Контактная Информация",
      address: "РА г. Вагаршапат, Шаумяна 39",
      allRights: "Все права защищены.",
      backToTop: "Наверх",
    },

    // Documents Modal
    docsModal: {
      badge: "Официальные Документы",
      title: "Прозрачность и Регламенты",
      desc: "Публичные отчеты и официальные условия абонентского обслуживания ООО «Реал Тайм».",
      tabReports: "Отчеты",
      tabTerms: "Условия и Положения",
      downloadPdf: "PDF",
      notFound: "Документы не найдены",
    },
  },

  en: {
    // Navigation
    nav: {
      tariffs: "Tariffs",
      speedtest: "Speed Test",
      coverage: "Coverage",
      about: "About Us",
      contacts: "Contacts",
      callUs: "Call: 060 666 999",
    },

    // Hero Banner
    hero: {
      badge: "Trusted Telecom Provider in Armenia since 2001",
      titlePart1: "ULTRA-FAST",
      titlePart2: "INTERNET",
      titlePart3: "& DIGITAL",
      titlePart4: "CATV",
      subtitle: "Ultra-reliable fiber optic connectivity up to 200 Mbps and 100+ premium digital television channels for your home and business.",
      viewTariffs: "View Tariffs",
      callDirect: "Call: 060 666 999",
    },

    // Tariffs Section
    tariffs: {
      badge: "Updated Tariffs",
      title: "Choose Your Package",
      subtitle: "High-speed fiber optic internet and digital television without interruptions. Tailored for residential and corporate clients.",
      tabBundle: "CATV + Internet",
      tabFiber: "Fiber Optic Internet",
      tabCorporate: "Corporate",
      popularBadge: "Most Popular",
      currency: "֏ / month",
      noHiddenFees: "No hidden fees",
      speedLabel: "Internet Speed",
      speedUpTo: "Up to",
      speedUnit: "Mbps",
      channelsLabel: "Digital CATV",
      channelsSub: "TV Channels",
      channelsUnit: "Channels",
      freeWifi: "Free Wi-Fi activation",
      techMonitoring: "24/7 Technical Monitoring",
      unlimitedTraffic: "Unlimited Traffic",
      transparencyTitle: "Transparency Metrics",
      normallyAvailable: "Normally Available:",
      minimumSpeed: "Minimum Guaranteed:",
      callButton: "Call: 060 666 999",
      helpTitle: "Need help selecting the best package?",
      helpSubtitle: "Our telecom specialists will help you choose the ideal speed and package for your location and needs.",
      helpButton: "Get Consultation",
    },

    // Speed Test & Calculator
    speedtest: {
      badge: "Speed and Precision",
      title: "Speed Test & Bandwidth Calculator",
      subtitle: "Verify your actual connection speed or calculate the optimal bandwidth requirement for your household.",
      serverTestBadge: "Direct Server Test",
      serverTestTitle: "Direct Speed Measurement",
      serverTestDesc: "Download a 10 GB test file directly from the Real Time central backbone server to test your maximum throughput and link stability.",
      noProxy: "Direct connection with no proxy bottlenecks or VPN limits",
      realMeasure: "Genuine provider throughput testing",
      downloadButton: "Download Speed Test File (10 GB)",
      calcBadge: "Interactive Tool",
      calcTitle: "Bandwidth Calculator",
      questionPeople: "How many people actively use the internet simultaneously?",
      peopleSmall: "1 - 2 People",
      peopleMedium: "3 - 4 People",
      peopleLarge: "5+ People",
      questionNeeds: "What are your primary online activities?",
      needStreaming: "4K Streaming",
      needGaming: "Online Gaming",
      needWork: "Remote Work",
      needSmartHome: "Smart Home",
      recBadge: "Recommended Package",
      callOperator: "Call Operator: 060 666 999",
    },

    // Coverage Section
    coverage: {
      badge: "Network Coverage",
      title: "Coverage Map",
      subtitle: "The Real Time fiber optic backbone spans dozens of communities across Armenia. Check your location below:",
      mapTitle: "Interactive Map",
      settlementsCount: "Settlements",
      markerFiber: "Fiber optic coverage points",
      markerActive: "Active connection zone",
      searchPlaceholder: "Search settlement (e.g. Oshakan, Alashkert...)",
      allRegions: "All",
      noResults: "No settlement found with this name",
      fiberAvailable: "Fiber",
      fiberNone: "No Fiber",
      cantFind: "Can't find your community?",
      checkByCall: "Inquire by Phone: 060 666 999",
    },

    // About Section
    about: {
      badge: "Our Story and Mission",
      title: "Reliable Connectivity Across Armenia",
      storyP1: "Real Time LLC was established in 2001. Starting in 2007, the company launched internet access services in Yerevan, subsequent to which it systematically expanded coverage to dozens of regional communities across Armenia.",
      storyP2: "Our core mission is to make robust, modern high-speed broadband accessible to rural and regional communities alike. By deploying modern equipment and carrier-grade fiber infrastructure, we continuously expand network availability for every family and enterprise.",
      feat1Title: "High-Speed Fiber (FTTH)",
      feat1Desc: "Modern fiber-to-the-home cable directly to your apartment or corporate office.",
      feat2Title: "100+ Digital CATV Channels",
      feat2Desc: "Crystal clear HD quality, diverse entertainment, news, discovery, and kids channels.",
      feat3Title: "99.9% Network Uptime",
      feat3Desc: "Redundant backbone nodes and high-reliability routing under all weather conditions.",
      feat4Title: "Daily Customer Care",
      feat4Desc: "Our dedicated technical support team is available every day from 09:00 to 24:00.",
    },

    // Contacts Section
    contacts: {
      badge: "Get in Touch",
      title: "Contact Us",
      subtitle: "For connection inquiries, tariffs, or technical support, call our dedicated customer hotline:",
      supportBannerBadge: "Dedicated Support",
      supportBannerTitle: "Customer Call Center",
      supportBannerHours: "Working Hours: 09:00 - 24:00 (Daily)",
      mobilePhonesTitle: "Mobile Operator Lines",
      emailTitle: "Email Contacts",
      emailHrTitle: "HR Department / Careers",
      emailGeneralTitle: "General Inquiries & Feedback",
      quickReply: "Prompt Response",
      quickReplyDesc: "We respond to all email inquiries within 24 hours on business days.",
      officeTitle: "Headquarters & Legal Office",
      addressLabel: "Address",
      addressValue: "RA Vagharshapat (Echmiadzin), 39 Shahumyan Street",
      coverageZoneLabel: "Service Coverage",
      coverageZoneValue: "Yerevan, Armavir Region, Aragatsotn Region, and adjacent regional communities.",
      officeHoursLabel: "Office Working Hours",
      officeHoursValue: "Monday - Saturday: 09:00 - 18:00",
      callAction: "Call Now",
      copyAction: "Copy",
      copied: "Copied",
      operatorsOnline: "Operators Online",
      viewCoverageMap: "View Coverage Map",
      openInMaps: "Open in Maps",
      mainHotlineBadge: "Main Hotline",
      callCenterDuty: "Technical Monitoring 24/7",
    },

    // Footer
    footer: {
      desc: "Real Time LLC — Trusted high-speed fiber optic internet and digital CATV television provider in Armenia since 2001.",
      quickLinks: "Quick Links",
      reports: "Reports",
      terms: "Terms & Conditions",
      contactInfo: "Contact Information",
      address: "RA Vagharshapat, 39 Shahumyan St",
      allRights: "All rights reserved.",
      backToTop: "Top",
    },

    // Documents Modal
    docsModal: {
      badge: "Official Documents",
      title: "Transparency & Terms",
      desc: "Public quarterly reports and official subscription terms and conditions of Real Time LLC.",
      tabReports: "Reports",
      tabTerms: "Terms & Conditions",
      downloadPdf: "PDF",
      notFound: "No documents found",
    },
  },
};
